var endPoints = {
    accountFeaturesUrl: "/v1/utility/account-management/product/features",
    accountSummaryUrl: "/v2/credit/accounts/summary",
    authAuthorize: "/v3/oauth2/authorize",
    authToken: "/v3/oauth2/token",
    creditAccountsUrl: "/v2/credit/accounts",
    logoutUrl: "/v3/oauth2/logout",
    statementsUrl: "/v1/credit/accounts/statements",
    statementsEnrollmentUrl: "/v1/credit/accounts/statements/enrollment",
    digitalAssets: "/assets/statements-mfe",
    userProfile: "/v1/credit/accounts/profile",
    statementsPrivacyPolicies: "/assets/statements-mfe/privacy-policies/policies-config.json",
};
export default endPoints;
